import React,{useState,useEffect,lazy} from 'react';
import axios from 'axios'
import {  Slider,Statistic,Tabs,Modal,Progress,Badge } from 'antd';
import { ArrowUpOutlined,MinusCircleFilled,ToolOutlined, ArrowDownOutlined,FileFilled,WalletFilled,SearchOutlined,FundViewOutlined,
   UserOutlined, AccountBookOutlined,OrderedListOutlined,CalculatorFilled,SwapOutlined,GroupOutlined,AccountBookFilled, DollarCircleOutlined,EditFilled,MessageFilled,DollarOutlined,CarFilled,LoadingOutlined,PlusCircleFilled,TrophyOutlined,CheckCircleOutlined,ExclamationCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import { Line,Pie,Bar,Doughnut } from 'react-chartjs-2';
import {withGetScreen} from 'react-getscreen'
import { Tooltip,Popover,Table,Popconfirm,Input, Button,Collapse,Card,Avatar,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import {
  Col,
  Row,
} from 'reactstrap';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import * as serverconfig from '../../serverconn'
import * as serversocketconfig from '../../serversocketconfig'
import { MdAndroid, MdShoppingCart } from 'react-icons/md';

import CurrencyFormat from 'react-currency-format';
import Highlighter from 'react-highlight-words';
import Websocket from 'react-websocket';
import { Link } from 'react-router-dom';
import ReconnectingWebSocket from 'reconnecting-websocket';
import { NavLink } from 'react-router-dom'
import * as primarycolor from '../../primarycolor'
import QuickMenu from './QuickMenu';

import SportsMotorsportsIcon from '@mui/icons-material/SportsMotorsports';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import LocalHospitalSharpIcon from '@mui/icons-material/LocalHospitalSharp';
import Inventory2SharpIcon from '@mui/icons-material/Inventory2Sharp';
import OpacityIcon from '@mui/icons-material/Opacity';
import TwoWheelerSharpIcon from '@mui/icons-material/TwoWheelerSharp';
import OnlineAgentsList from './OnlineAgentsListView';
import OrdersList from './OrdersListView'
import DeliveriesList from './DeliveriesListView'
import AgentActivityMap from './AgentActivityMap'
import PendingUmojaPickupsList from './PendingUmojaPickupsList';
import SampleBarCodeForm from '../components/SampleBarCodeForm'
import SamplesChart from '../components/SamplesChart'
import CentralHubChart from '../components/CentralHubChart'
import GraphsComponent from './GraphsComponent';

var CryptoJS = require("crypto-js");

const { TextArea } = Input;
const { Title, Text } = Typography;
const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;


const style = { background: '#0092ff', padding: '8px 0',borderRadius: '7px',justifyContent:'center', alignItems:'center',display: 'flex', };
const dateFormat = 'DD/MM/YYYY';
const yeardateFormat = 'YYYY';
const monthdateFormat = 'MM/YYYY';

const { Meta } = Card;
const { Panel } = Collapse;
const { TabPane } = Tabs;
const FormItem=Form.Item;
const { Option } = Select;


var bizuserid= ''
var instance_id= ''
var token= ''
var notificationsocket = new ReconnectingWebSocket(serversocketconfig.socketurl+'/ws/notificationsocket/');
var agentlocationsocket = new ReconnectingWebSocket(serversocketconfig.socketurl+'/ws/agentlocationsocket/');


class MainControlDashBoard extends React.Component {

  state = {
    currentmonth:moment().format(monthdateFormat).toString(),
    companyprofile:{},
    datarequested:true,
    memberformvisible:false,
    transactformvisible:false,
    calculatorformvisible:false,
    members:[],
    loansformvisible:false,
    dashboardlocked:false,
    utilitiesmodalvisible:false,
    userprofile:{},
    userrights:{},
    nonworkingday:{},
    depositsno:0,
    withdrawsno:0,
    depositvolume:0,
    withdrawvolume:0,
    tranquerymode:'Daily',
    expensevolumes:0,
    incomevolumes:0,
    datareload:false,
    withdrawpercentage:0,
    withdrwdiff:0,
    depositpercentage:0,
    depositdiff:0,
    percenategincomes:0,
    incomediff:0,
    percenategexpnses:0,
    expensdiff:0,
    weeklydays:[],
    weeklydeposits:[],
    weeklywithdraws:[],
    weeklyincomes:[],
    weeklyexpenses:[],

    weeklychartdata:[],
    weeklychartitems:[],

    graphtranquerymode:'weekly',
    loanproccessuerymode:'daily',

    totalapplications:0,
    totalapplicationamounts:0,
    totalassessments:0,
    totalassessmentsamounts:0,
    totalapprovals:0,
    totalapprovalsamounts:0,
    totaldisbursements:0,
    totaldisbursementsamounts:0,

    projectedmonths:"three",
    monthsprojected:[],
    projectedinterest:[],
    projectedprinciple:[],

    applicationvsdates:[],
    applicationvs:[],
    issuancesvs:[],
    applicvsmode:'weekly',

    total_of_agents:0,

    healthcentres:[],
    collectionhubs:[],
    samples:[],
    supplies:[],
    healthcentres:[],
    delivery_agents:[],
    pending_deliveries:[],
    pending_umoja_pickups:[],
    products:[],
    delivery_agents_all:[],
    app_clients:[],
    delivered_to_hubs_list:[],
    delivered_to_centralhub_list:[],
    recent_deliveries:[],
    system_performance:{},




  };






  callback =(key) =>{
    console.log(key);
    console.log(this.state.yearlymonthlysales)
  }

  // Generate sample performance data
  generatePerformanceData = () => {
    const totalDeliveries = this.state.pending_deliveries.length; // Use actual pending deliveries
    const completedDeliveries = 0; // Will be calculated from actual API data
    const onTimeDeliveries = 0; // Will be calculated from actual API data
    const avgDeliveryTime = 0; // Will be calculated from actual API data

    return {
      totalDeliveries,
      completedDeliveries,
      onTimeDeliveries,
      avgDeliveryTime,
      completionRate: totalDeliveries > 0 ? ((completedDeliveries / totalDeliveries) * 100).toFixed(1) : "0.0",
      onTimeRate: completedDeliveries > 0 ? ((onTimeDeliveries / completedDeliveries) * 100).toFixed(1) : "0.0"
    };
  }

  // Generate chart data for deliveries over time
  generateDeliveryTrendData = () => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
    const deliveries = [0, 0, 0, 0, 0, 0]; // Will be populated from actual data
    const completions = [0, 0, 0, 0, 0, 0]; // Will be populated from actual data

    return {
      labels: months,
      datasets: [
        {
          label: 'Total Deliveries',
          data: deliveries,
          borderColor: 'rgba(54, 162, 235, 1)',
          backgroundColor: 'rgba(54, 162, 235, 0.1)',
          borderWidth: 3,
          fill: true,
          tension: 0.4,
        },
        {
          label: 'Completed Deliveries',
          data: completions,
          borderColor: 'rgba(75, 192, 192, 1)',
          backgroundColor: 'rgba(75, 192, 192, 0.1)',
          borderWidth: 3,
          fill: true,
          tension: 0.4,
        }
      ]
    };
  }

  // Generate pie chart data for sample types
  generateSampleTypesData = () => {
    // Calculate actual sample distribution from samples data
    const sampleTypesCount = {};
    
    this.state.samples.forEach(sample => {
      const type = sample.sample_type || sample.name || 'Unknown';
      sampleTypesCount[type] = (sampleTypesCount[type] || 0) + 1;
    });

    const sampleTypes = Object.keys(sampleTypesCount);
    const counts = Object.values(sampleTypesCount);
    
    // Default colors for different sample types
    const colors = [
      'rgba(255, 99, 132, 0.8)',
      'rgba(54, 162, 235, 0.8)',
      'rgba(255, 206, 86, 0.8)',
      'rgba(75, 192, 192, 0.8)',
      'rgba(153, 102, 255, 0.8)'
    ];

    return {
      labels: sampleTypes.length > 0 ? sampleTypes : ['No Data'],
      datasets: [{
        data: counts.length > 0 ? counts : [1],
        backgroundColor: sampleTypes.length > 0 ? colors.slice(0, sampleTypes.length) : ['rgba(200, 200, 200, 0.8)'],
        borderColor: sampleTypes.length > 0 ? colors.slice(0, sampleTypes.length).map(color => color.replace('0.8', '1')) : ['rgba(200, 200, 200, 1)'],
        borderWidth: 2,
      }]
    };
  }

  componentDidMount(){

    if(localStorage.getItem("instance_id")){
      instance_id= localStorage.getItem("instance_id")
    }else{
      instance_id= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }


    if(localStorage.getItem("bizuserid")){
      bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
   }else{
      bizuserid= ''
   }
    
    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

   axios.get(serverconfig.backendserverurl+`/api/accounts/${bizuserid}`)
   .then(res => {
       this.setState({
        userprofile:res.data
       })
   })


   axios.get(serverconfig.backendserverurl+`/api/healthcentres`)
   .then(res => {
       this.setState({healthcentres:res.data})
   })

   axios.get(serverconfig.backendserverurl+`/api/collectionhubs`)
   .then(res => {
       this.setState({collectionhubs:res.data})
   })

   axios.get(serverconfig.backendserverurl+`/api/samples`)
   .then(res => {
       this.setState({samples:res.data})

   })

   axios.get(serverconfig.backendserverurl+`/api/supplies`)
   .then(res => {
       this.setState({supplies:res.data})
   })


   axios.get(serverconfig.backendserverurl+`/api/delivery_agents/`)
   .then(res => {
       this.setState({delivery_agents_all:res.data})
   })

   axios.get(serverconfig.backendserverurl+`/api/app_clients/`)
   .then(res => {
       this.setState({app_clients:res.data})
   })

   axios.get(serverconfig.backendserverurl+`/api/products`)
   .then(res => {
       this.setState({products:res.data})
   })

   axios.get(serverconfig.backendserverurl+`/api/pending_deliveries/?trip_status=${"ongoing"}`)
   .then(res => {
       this.setState({pending_deliveries:res.data})
   })

   // Load pending Umoja pickups data
   axios.get(serverconfig.backendserverurl+`/api/pending_umoja_pickups/`)
   .then(res => {
       this.setState({pending_umoja_pickups:res.data})
   })
   .catch(error => {
       console.error('Error loading pending Umoja pickups:', error);
   })

   // Chart data will be populated from actual API calls when available
   // delivered_to_hubs_list and delivered_to_centralhub_list remain empty by default


   axios.get(serverconfig.backendserverurl+`/api/app_profile/${1}`)
   .then(res => {
       this.setState({
         companyprofile:res.data
       })

   })

   axios.get(serverconfig.backendserverurl+`/api/accountrights/?user=${bizuserid}`)
   .then(res => {
      console.log("data: "+res.data[0] )
       this.setState({
         userrights:res.data[0]
       })
   })


   notificationsocket.onmessage = async (e) => {
    axios.get(serverconfig.backendserverurl+`/api/pending_deliveries/?trip_status=${'ongoing'}`)
    .then(res => {
        this.setState({
            pending_deliveries:res.data
        })
    })

  };


  axios.get(serverconfig.backendserverurl+`/api/delivery_agents/?is_online=${true}&active=${true}`)
  .then(res => {
      this.setState({
        delivery_agents:res.data
      })

      //set datarequested to false after all data is loaded
      this.setState({datarequested:false})
  })






    //rerold on agnet location change
    agentlocationsocket.onmessage = async (e) => {
      //just update agent location

      axios.get(serverconfig.backendserverurl+`/api/delivery_agents/?is_online=${true}&active=${true}`)
      .then(res => {
          this.setState({
            delivery_agents:res.data
          })  
      }) 

    };

}

render() {

if(this.state.dashboardlocked===true){
  return(
    <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
    <h3 style={{fontWeight:'bolder',color:'red'}}>NOTE: Your dashboard is currently locked. Contact system adminstrators.Your Licence may be expired or some thing else. Thanks</h3>
    </div>
  )
}else{

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )
     }else{
     
        return(
         <div className="animated fadeIn">  
        <Tabs >

          {
            this.state.userrights.view_statistics===true && this.state.userprofile.branch_manager===true?
            <TabPane tab="📊 Dashboard Overview" key="01" >

              {/* Header Section */}
              <div style={{ marginBottom: '24px' }}>
                <Title level={2} style={{ color: primarycolor.primarycolor, marginBottom: '8px' }}>
                  <TrophyOutlined /> System Overview Dashboard
                </Title>
                <Text type="secondary">
                  Real-time monitoring and analytics for Umoja Medical Courier System
                </Text>
              </div>


              {/* System Statistics Cards */}
              <Row gutter={[24, 24]} style={{ marginTop: '32px', marginBottom: '24px' }}>
                <Col xs={12} sm={6} lg={3}>
                  <NavLink to='/deliveryagents/'> 
                    <Card hoverable className="stat-card" style={{ 
                      textAlign: 'center', 
                      borderRadius: '12px', 
                      boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                      margin: '12px',
                      border: '1px solid #f0f0f0',
                      transition: 'all 0.3s ease'
                    }}>
                      <div style={{ padding: '20px 12px' }}>
                        <SportsMotorsportsIcon style={{ color: primarycolor.primarycolor, fontSize: 36, marginBottom: '12px' }} />
                        <Title level={4} style={{ margin: '8px 0 4px 0', color: primarycolor.primarycolor, fontSize: '18px' }}>
                          {this.state.delivery_agents_all.length}
                        </Title>
                        <Text type="secondary" style={{ fontSize: '12px' }}>Total Agents</Text>
                      </div>
                    </Card>
                  </NavLink>
                </Col>

                <Col xs={12} sm={6} lg={3}>
                  <NavLink to='/app_clients/'> 
                    <Card hoverable className="stat-card" style={{ 
                      textAlign: 'center', 
                      borderRadius: '12px', 
                      boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                      margin: '12px',
                      border: '1px solid #f0f0f0',
                      transition: 'all 0.3s ease'
                    }}>
                      <div style={{ padding: '20px 12px' }}>
                        <MdAndroid style={{ color: primarycolor.primarycolor, fontSize: 36, marginBottom: '12px' }} />
                        <Title level={4} style={{ margin: '8px 0 4px 0', color: primarycolor.primarycolor, fontSize: '18px' }}>
                          {this.state.app_clients.length}
                        </Title>
                        <Text type="secondary" style={{ fontSize: '12px' }}>App Clients</Text>
                      </div>
                    </Card>
                  </NavLink>
                </Col>

                <Col xs={12} sm={6} lg={3}>
                  <NavLink to='/collectionhubs/'> 
                    <Card hoverable className="stat-card" style={{ 
                      textAlign: 'center', 
                      borderRadius: '12px', 
                      boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                      margin: '12px',
                      border: '1px solid #f0f0f0',
                      transition: 'all 0.3s ease'
                    }}>
                                              <div style={{ padding: '20px 12px' }}>
                        <LocalHospitalIcon style={{ color: primarycolor.primarycolor, fontSize: 36, marginBottom: '12px' }} />
                        <Title level={4} style={{ margin: '8px 0 4px 0', color: primarycolor.primarycolor, fontSize: '18px' }}>
                          {this.state.collectionhubs.length}
                        </Title>
                        <Text type="secondary" style={{ fontSize: '12px' }}>Collection Hubs</Text>
                      </div>
                    </Card>
                  </NavLink>
                </Col>

                <Col xs={12} sm={6} lg={3}>
                  <NavLink to='/healthcenters/'> 
                    <Card hoverable className="stat-card" style={{ 
                      textAlign: 'center', 
                      borderRadius: '12px', 
                      boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                      margin: '12px',
                      border: '1px solid #f0f0f0',
                      transition: 'all 0.3s ease'
                    }}>
                      <div style={{ padding: '20px 12px' }}>
                        <LocalHospitalSharpIcon style={{ color: primarycolor.primarycolor, fontSize: 36, marginBottom: '12px' }} />
                        <Title level={4} style={{ margin: '8px 0 4px 0', color: primarycolor.primarycolor, fontSize: '18px' }}>
                          {this.state.healthcentres.length}
                        </Title>
                        <Text type="secondary" style={{ fontSize: '12px' }}>Spokes</Text>
                      </div>
                    </Card>
                  </NavLink>
                </Col>

                <Col xs={12} sm={6} lg={3}>
                  <NavLink to='/supplies/'> 
                    <Card hoverable className="stat-card" style={{ 
                      textAlign: 'center', 
                      borderRadius: '12px', 
                      boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                      margin: '12px',
                      border: '1px solid #f0f0f0',
                      transition: 'all 0.3s ease'
                    }}>
                      <div style={{ padding: '20px 12px' }}>
                        <Inventory2SharpIcon style={{ color: primarycolor.primarycolor, fontSize: 36, marginBottom: '12px' }} />
                        <Title level={4} style={{ margin: '8px 0 4px 0', color: primarycolor.primarycolor, fontSize: '18px' }}>
                          {this.state.supplies.length}
                        </Title>
                        <Text type="secondary" style={{ fontSize: '12px' }}>Total Supplies</Text>
                      </div>
                    </Card>
                  </NavLink>
                </Col>

                <Col xs={12} sm={6} lg={3}>
                  <NavLink to='/samples/'> 
                    <Card hoverable className="stat-card" style={{ 
                      textAlign: 'center', 
                      borderRadius: '12px', 
                      boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                      margin: '12px',
                      border: '1px solid #f0f0f0',
                      transition: 'all 0.3s ease'
                    }}>
                      <div style={{ padding: '20px 12px' }}>
                        <OpacityIcon style={{ color: primarycolor.primarycolor, fontSize: 36, marginBottom: '12px' }} />
                        <Title level={4} style={{ margin: '8px 0 4px 0', color: primarycolor.primarycolor, fontSize: '18px' }}>
                          {this.state.samples.length}
                        </Title>
                        <Text type="secondary" style={{ fontSize: '12px' }}>Total Samples</Text>
                      </div>
                    </Card>
                  </NavLink>
                </Col>

                <Col xs={12} sm={6} lg={3}>
                  <NavLink to='/products/'> 
                    <Card hoverable className="stat-card" style={{ 
                      textAlign: 'center', 
                      borderRadius: '12px', 
                      boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                      margin: '12px',
                      border: '1px solid #f0f0f0',
                      transition: 'all 0.3s ease'
                    }}>
                      <div style={{ padding: '20px 12px' }}>
                        <OrderedListOutlined style={{ color: primarycolor.primarycolor, fontSize: 36, marginBottom: '12px' }} />
                        <Title level={4} style={{ margin: '8px 0 4px 0', color: primarycolor.primarycolor, fontSize: '18px' }}>
                          {this.state.products.length}
                        </Title>
                        <Text type="secondary" style={{ fontSize: '12px' }}>Total Products</Text>
                      </div>
                    </Card>
                  </NavLink>
                </Col>


              </Row>

            </TabPane>
            :
            null
          }


          {
            this.state.userrights.view_statistics===true && this.state.userprofile.branch_manager===true?
            <TabPane tab="📊 Tracking Overview" key="0001" >
              <GraphsComponent/>
            </TabPane>
            :
            null
          }



        </Tabs>


          </div>
      )
    }
  
 }

}
}

export default MainControlDashBoard; 
